<template>
  <div>
    <v-row>
      <v-col cols="12" md="3">
        <v-text-field
          v-model="search"
          clearable
          outlined
          dense
          height="40px"
          label="Search name, email, or etc."
          prepend-inner-icon="mdi-magnify"
          color="primary"
          class="rounded-lg"
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="2">
        <v-autocomplete
          auto-select-first
          clearable
          :menu-props="{
            bottom: true,
            offsetY: true,
          }"
          append-icon="mdi-chevron-down"
          v-model="state"
          :items="state_list"
          :search-input.sync="state_search"
          :loading="state_list_loading"
          item-text="name"
          item-value="id"
          outlined
          dense
          no-filter
          height="40px"
          label="Filter by State"
          class="rounded-lg"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="2">
        <v-autocomplete
          auto-select-first
          clearable
          :menu-props="{
            bottom: true,
            offsetY: true,
          }"
          append-icon="mdi-chevron-down"
          v-model="city"
          :items="city_list"
          :search-input.sync="city_search"
          :loading="city_list_loading"
          item-text="name"
          item-value="id"
          outlined
          dense
          no-filter
          height="40px"
          label="Filter by City"
          class="rounded-lg"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="5" class="text-right">
        <v-btn
          class="text-capitalize px-7 rounded-lg"
          color="primary"
          outlined
          height="40px"
          @click="addEca({ show: true, id: '', type: 'add' })"
        >
          <v-icon size="16" left>mdi-plus</v-icon>Add New ECA Body
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      class="elevation-3"
      :items-per-page="page_count"
      :server-items-length="page_count"
      :loading="loading"
      loading-text="Please wait.... Loading"
      :headers="headers"
      :items="items"
      hide-default-footer
      mobile-breakpoint
    >
      <template v-slot:[`item.created`]="{ item }">
        {{ $utils.formatDate(item.created) }}
      </template>

      <template v-slot:[`item.name`]="{ item }">
        {{ item.name }}
      </template>

      <template v-slot:[`item.remarks`]="{ item }">
        <div class="">
          <div v-if="item.remarks">{{ item.remarks }}</div>
          <v-edit-dialog
            @save="onSave(item.id, 'remarks')"
            @open="editDialog.remarks = item.remarks"
            large
            transition="slide-y-transition"
          >
            <div class="primary--text d-flex align-center text-caption">
              <span v-if="item.remarks">
                <v-icon small color="primary">mdi-pencil</v-icon>
                Edit Remarks
              </span>
              <span v-else>
                <v-icon small color="primary">mdi-plus</v-icon>
                Add Remarks
              </span>
            </div>
            <template v-slot:input>
              <div class="my-4">Remarks</div>
              <v-textarea
                v-model="editDialog.remarks"
                rows="3"
                type="text"
                flat
                outlined
                dense
                class="rounded-lg"
              ></v-textarea>
            </template>
          </v-edit-dialog>
        </div>
      </template>

      <template v-slot:[`item.contact`]="{ item }">
        <div class="">
          <div v-if="item.user.mobile || item.user.email || item.full_address">
            <div v-if="item.user.mobile">{{ item.user.mobile_display }}</div>
            <div v-if="item.user.email">{{ item.user.email }}</div>
            <div v-if="item.full_address">{{ item.full_address }}</div>
          </div>
          <v-icon v-else>mdi-minus</v-icon>
        </div>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <v-switch
          color="success"
          v-model="item.is_active"
          @change="changeStatus(item.is_active, item.id)"
          :label="item.is_active ? 'Active' : 'In-active'"
        ></v-switch>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <div class="d-flex justify-center" style="gap: 10px">
          <v-btn
            small
            outlined
            class="text-capitalize rounded-lg"
            color="primary"
            height="32px"
            @click="
              addEca({
                show: true,
                type: 'edit',
                id: item.id,
              })
            "
          >
            edit
          </v-btn>
          <v-btn
            small
            outlined
            class="text-capitalize rounded-lg"
            color="primary"
            height="32px"
            @click="
              toggleConfirmationDialog({ show: true, action: 'delete' }),
                (user_id = item.id)
            "
          >
            delete
          </v-btn>
        </div>
      </template>
    </v-data-table>

    <v-container
      class="d-flex justify-space-between align-center px-0 mb-0 mt-4"
      fluid
    >
      <div class="d-flex align-center text-subtitle-2">
        <div class="mr-2">Rows per page</div>
        <div style="width: 75px">
          <v-select
            :menu-props="{ bottom: true, offsetY: true }"
            :items="itemsPerPageList"
            v-model="page_count"
            hide-details
            dense
            solo
            color="primary"
            class="rounded-lg"
          ></v-select>
        </div>
        <div class="ml-6">
          Results: {{ pageStart }} - {{ pageEnd }} of {{ total_count }}
        </div>
      </div>
      <v-pagination
        v-model="page_number"
        :length="page_total"
        :total-visible="5"
        color="primary"
      >
      </v-pagination>
    </v-container>
    <ConfirmationDialog @confirmed="deleteUser" height="130px" width="130px">
      <template v-slot:confirmBtnText> Yes Delete </template>
    </ConfirmationDialog>
    <add-eca @reload-list="getEcaList" />
  </div>
</template>
<script>
import _ from "lodash";

import { mapActions } from "vuex";

import AddEca from "./addEca.vue";
import ConfirmationDialog from "@/components/Dialogs/ConfirmationDialog";

export default {
  components: { ConfirmationDialog, AddEca },
  name: "ecaManagement",
  data() {
    return {
      itemsPerPageList: [5, 10, 15, 20, 30, 40, 50],
      page_total: 1,
      page_number: 1,
      page_count: 10,
      total_count: 0,
      items: [],
      search: "",
      user_id: null,
      loading: false,
      headers: [
        {
          sortable: false,
          text: "Date  Joined",
          value: "created",
          width: 120,
        },
        {
          sortable: false,
          text: "Name",
          value: "name",
        },
        {
          sortable: false,
          text: "Contact",
          value: "contact",
          width: 250,
        },
        {
          sortable: false,
          text: "Remarks",
          value: "remarks",
          width: 250,
        },
        {
          sortable: false,
          text: "Status",
          width: 150,
          value: "status",
        },
        {
          sortable: false,
          text: "Action",
          width: 200,
          value: "action",
        },
      ],

      state: null,
      state_list: [],
      state_search: "",
      state_list_loading: false,

      city: null,
      city_list: [],
      city_search: "",
      city_list_loading: false,

      editDialog: {
        cost: 0,
        remarks: "",
      },
    };
  },
  watch: {
    search() {
      this.debouncedReloadData();
    },

    state() {
      this.getEcaList();
    },

    city() {
      this.getEcaList();
    },

    page_count() {
      this.getEcaList();
    },

    page_number() {
      this.getEcaList();
      this.updateRoute();
    },

    state_search: _.debounce(function (query) {
      if (this.state_list_loading) return;

      if (query && !this.state) {
        this.getStateList();
      }
    }, 1000),

    city_search: _.debounce(function (query) {
      if (this.city_list_loading) return;

      if (query && !this.city) {
        this.getCityList();
      }
    }, 1000),
  },

  computed: {
    pageStart() {
      let start = (this.page_number - 1) * this.page_count + 1;
      if (start + 1 > this.total_count) start = this.total_count;
      return start;
    },

    pageEnd() {
      let end = this.pageStart + this.page_count - 1;
      if (end > this.total_count) end = this.total_count;
      return end;
    },
  },

  created() {
    const query = this.$route.query;

    if (query.page) {
      this.page_number = Number(query.page);
    }

    this.updateRoute();
  },

  mounted() {
    this.getEcaList();
    this.$root.$on("onNavClicked", this.navClickHandler);
  },

  methods: {
    ...mapActions({
      toggleConfirmationDialog: "dialogs/toggleConfirmationDialog",
      setConfirmationDialogBtnLoading:
        "dialogs/setConfirmationDialogBtnLoading",
      addEca: "admin/addEca",
      showSnackbar: "app/showSnackbar",
    }),

    navClickHandler(navKey) {
      if (navKey === "eca_management") {
        this.getEcaList();
        this.updateRoute();
      }
    },

    debouncedReloadData: _.debounce(function () {
      this.getEcaList();
      this.updateRoute();
    }, 1000),

    updateRoute() {
      const query = {};

      if (this.page_number) {
        query.page = Number(this.page_number);
      }

      this.$router
        .replace({
          path: this.$route.path,
          query: query,
        })
        .catch((error) => error);
    },

    getStateList() {
      this.state_list_loading = true;

      const params = {
        apply_pagination: false,
        search: this.state_search,
      };

      const onSuccess = (res) => {
        this.state_list = res.data.data;
      };

      const onFinally = () => {
        this.state_list_loading = false;
      };

      return this.$request(this.$keys.GET, this.$urls.master.state.list, {
        params,
        onSuccess,
        onFinally,
      });
    },

    getCityList() {
      this.city_list_loading = true;

      const params = {
        apply_pagination: false,
        state_id: this.state,
        search: this.city_search,
      };

      const onSuccess = (res) => {
        this.city_list = res.data.data;
      };

      const onFinally = () => {
        this.city_list_loading = false;
      };

      return this.$request(this.$keys.GET, this.$urls.master.city.list, {
        params,
        onSuccess,
        onFinally,
      });
    },

    getEcaList() {
      this.loading = true;
      this.items = [];

      const params = {};
      params["page_number"] = this.page_number;
      params["page_count"] = this.page_count;
      if (this.search) params["search"] = this.search;
      if (this.state) params["state_id"] = this.state;
      if (this.city) params["city_id"] = this.city;

      const onSuccess = (res) => {
        this.page_total = res.data.page_info.page_total;
        this.page_number = res.data.page_info.page_number;
        this.total_count = res.data.page_info.total_count;
        this.items = res.data.data;
      };

      const onFinally = () => {
        this.loading = false;
      };

      this.$request(this.$keys.GET, this.$urls.eca.list, {
        params,
        onSuccess,
        onFinally,
      });
    },

    deleteUser() {
      const params = {};
      params["eca_body_id"] = this.user_id;

      const onSuccess = (res) => {
        this.toggleConfirmationDialog({ show: false });
        this.showSnackbar({
          text: res.data.message,
          color: "success",
        });
        this.getEcaList();
      };

      const onFinally = () => {
        this.setConfirmationDialogBtnLoading({ loading: false });
      };

      this.$request(this.$keys.DELETE, this.$urls.eca.delete, {
        params,
        onSuccess,
        onFinally,
      });
    },

    changeStatus(value, id) {
      const params = {};
      params["eca_body_id"] = id;

      const data = {};
      data["is_active"] = value;

      this.$request(this.$keys.PUT, this.$urls.eca.update, {
        params,
        data,
      });
    },

    onEdit(params, data) {
      const onSuccess = () => {
        this.getEcaList();
      };

      this.$request(this.$keys.PUT, this.$urls.eca.update, {
        params,
        data,
        onSuccess,
      });
    },

    onSave(id, field) {
      const data = {};
      const params = {
        eca_body_id: id,
      };

      switch (field) {
        case "remarks":
          data["remarks"] = this.editDialog.remarks;
          this.onEdit(params, data);
          break;
        default:
          break;
      }
    },
  },
};
</script>